import { render } from "./Cities.vue?vue&type=template&id=bb67f038&scoped=true"
import script from "./Cities.vue?vue&type=script&lang=js"
export * from "./Cities.vue?vue&type=script&lang=js"

import "./Cities.vue?vue&type=style&index=0&id=bb67f038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb67f038"]])

export default __exports__